interface LoadingProps {
  size?: 'xsmall' | 'small' | 'medium';
}

export default function Loading({ size = 'medium' }: LoadingProps) {
  const sizes = {
    xsmall: { width: 20, height: 20, borderWidth: 2 },
    small: { width: 40, height: 40, borderWidth: 3 },
    medium: { width: 48, height: 48, borderWidth: 4 },
  };

  const currentSize = sizes[size];

  return (
    <div className="flex items-center justify-center p-4">
      <div
        className="animate-spin"
        style={{
          width: currentSize.width,
          height: currentSize.height,
          borderRadius: '50%',
          border: `${currentSize.borderWidth}px solid #005FFF`,
          borderTopColor: 'transparent',
          display: 'block',
        }}
      />
    </div>
  );
}
